export default {
  grades: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  grade:[],
  selected_grade : {},
  grade_status:[]
}
